<template>
  <div @click="onEventAction" v-click-outside="onClickOutside">

    <qc-table-client-pagination ref="table" :row-class-name="()=>'finder-item'" :loading="loading" :list="list"
      :min-height="`${tableHeight}px`" :max-height="`${tableHeight}px`" :pageSize="pageSize" :currPage="currPage">
      <qc-table-column :label="$t('core.name')" class="table-file">
        <template slot-scope="{ item, rowIndex }">
          <div class="finder-item-name" :class="{'checked':item.checked}" :title="item.name">
            <div class="cos-icon--32" :class=" item.name | FileIcon(item.isDir)"
              :style="`cursor:${item.isDir ? 'pointer':'default'}`"></div>
            <a href="javascript:void(0)" class="table-file__name text-overflow" :class="{'no-highlight':!item.isDir}"
              draggable="false" :data-index="(currPage-1)*pageSize+rowIndex"
              data-action="openFolderOrFile">{{item.name}}</a>
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('cos.storage_class')" width="100px">
        <template slot-scope="{ item }">
          <div>
            {{ item.StorageClass | StorageClassShortText }}
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('core.size')" field="sizeText" width="100px">
        <template slot="header">
           <div @click="sortClick('sortBySize')">
             <span class="tc-15-th-sort-btn">
               <span :title="$t('core.size')" class="text-overflow">{{$t('core.size')}}</span>
               <qc-icon :type="sortBySizeIcon"></qc-icon>
              </span>
            </div>
         </template>
      </qc-table-column>

      <qc-table-column :label="$t('core.mtime')" field="mtime" width="160px">
        <template slot="header">
           <div @click="sortClick('sortByTime')">
             <span class="tc-15-th-sort-btn">
               <span :title="$t('core.mtime')" class="text-overflow">{{$t('core.mtime')}}</span>
               <qc-icon :type="sortByTimeIcon"></qc-icon>
              </span>
            </div>
         </template>
      </qc-table-column>

      <qc-table-column :label="$t('core.location')" field="location" width="180px" v-if="searchStatus.isSearched">
        <template slot-scope="{ item }">
          <div class="id-name-cell">
            <a href="javascript:;" class="text-primary text-overflow" :title="item.location"
              @click="showInRemoteFolder(item)">
              {{item.location || '-'}}
            </a>
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('core.action')" width="140px">
        <template slot-scope="{ item, rowIndex }">
          <div class="tc-g cos-table-operate">
            <div class="tc-g-u-1-3">
              <!-- {{item.StorageClass}} -->
              <qc-bubble trigger="hover" type="dark"
                v-if="!['ARCHIVE','DEEP_ARCHIVE'].includes(item.StorageClass)">
                <div class="container-icon" :data-index="(currPage-1)*pageSize+rowIndex" data-action="fastCopyLink">
                  <div class="cos-icon--16 share">
                  </div>
                </div>
                <template slot="popup">
                  <div v-html="$t('core.share')"></div>
                </template>
              </qc-bubble>
              <!-- 占位 -->
              <div class="custom-operate-span container-icon no-hover" v-else>
                <div class="cos-icon--16" style="pointer-events: none;"></div>
              </div>
            </div>

            <div class="tc-g-u-1-3">
              <div v-if="!['ARCHIVE','DEEP_ARCHIVE'].includes(item.StorageClass)" class="container-icon"
                :data-index="(currPage-1)*pageSize+rowIndex" data-action="download">
                <div class="cos-icon--16 download">
                </div>
              </div>

              <!-- 占位 -->
              <div class="custom-operate-span container-icon no-hover" v-else>
                <div class="cos-icon--16" style="pointer-events: none;"></div>
              </div>
            </div>

            <div class="tc-g-u-1-3">
              <div class="custom-operate-span container-icon" :data-index="(currPage-1)*pageSize+rowIndex"
                data-action="dropmenu">
                <div class="cos-icon--16 more allow-selection"></div>
              </div>
            </div>
          </div>
        </template>
      </qc-table-column>

      <template slot="empty-tips">
        <div class="table-body blank" :style="`height:${tableHeight-50}px;min-height:200px;`">
          <template v-if="!hasAuthority">
            <div class="blank-img no-access"></div>
            <div class="blank-title">{{$t('cos.tips.no_access_to_bucket')}}</div>
            <div class="blank-help">{{$t('cos.tips.concat_root_to_auth')}}</div>
          </template>
          <template v-else>
            <template v-if="searchStatus.isSearchDone">
              <div class="blank-img lost"></div>
              <div class="blank-title">{{$t('cos.tips.no_result_found')}}</div>
              <div class="blank-help">{{$t('cos.tips.try_diffrent_keyword')}}</div>
            </template>
            <template v-else-if="!searchStatus.isSearchDone && !searchStatus.isSearching">
              <div class="blank-img empty"></div>
              <div class="blank-title">{{$t('cos.tips.empty_folder')}}</div>
              <!-- <div class="blank-help">{{$t('cos.tips.drag_here')}}</div> -->
            </template>
          </template>
        </div>
      </template>

      <template slot="pagination">
        <slot name="footer"></slot>
      </template>
    </qc-table-client-pagination>

    <file-dropmenu :show.sync="dropmenuShow" :position="dropmenuPosition" :options="dropmenuOptions" :action="action"
      @on-action="onAction">
    </file-dropmenu>
    <context-menu :show.sync="contextMenuShow" :position="contextMenuPosition"
      @on-action="onAction($event, 'contextmenu')"></context-menu>
  </div>
</template>

<script>

import $ from 'jquery';
import { config } from '@/scripts/tools/config';
import eventProxy from '@/scripts/tools/eventProxy';
import {
  getScrollbarWidth, getInnerProps,
  isAllowPreviewImageKey, isAllowPreviewVideoKey, isAllowPreviewAudioKey,
} from '@/scripts/tools/utils';

import fileDropmenu from '@/components/common/fileDropmenu.vue';
import contextMenu from '@/components/common/contextMenu.vue';

export default {
  components: {
    fileDropmenu,
    contextMenu,
  },
  model: {
    prop: 'list',
    event: 'update:list',
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    selectedList: {
      type: Array,
      required: true,
    },
    loading: {
      Type: Boolean,
      required: true,
      default: false,
    },
    hasAuthority: {
      type: Boolean,
      required: true,
      default: true,
    },
    searchStatus: {
      type: Object,
      required: true,
    },
    sortStatus: {
      type: Object,
      required: true,
    },
    currPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tableHeight: 300,
      // 排序
      sortFields: {
        sortBySize: 'none',
        sortByTime: 'none',
      },
      sortIconMap: {
        none: 'sort-arrow',
        asc: 'sort-arrow-up',
        desc: 'sort-arrow-dowm',
      },
      contextMenuShow: false,
      contextMenuPosition: {},
      // action 变量用来给 dropmenu 组件判断，将 click-outside 忽略打开菜单的操作按钮
      // (即将该操作按钮不视为点击元素外部)
      action: '',
      dropmenuAction: '', // dropmenu 组件的动作
      dropmenuShow: false,
      dropmenuPosition: {},
      dropmenuOptions: {},
      halfTableTop: 0,
      fileBody: null,
      selectedItem: {},
    };
  },
  computed: {
    innerSelectedList: getInnerProps('selectedList'),
    searchBarExist() {
      const showSearchBar = (this.searchStatus.isSearching || this.searchStatus.isSearchDone)
        && this.searchStatus.showSearchBar;
      const showSortBar = (this.sortStatus.isSorting || this.sortStatus.isSortDone)
        && this.sortStatus.showSortBar;
      return showSearchBar || showSortBar;
    },
    actionProxy: {
      get() {
        return {
          action: this.dropmenuAction,
          item: this.selectedItem,
        };
      },
      set(val) {
        this.$emit('on-action', val);
      },
    },
    sortBySizeIcon() {
      const sortType = this.sortFields.sortBySize;
      return this.sortIconMap[sortType];
    },
    sortByTimeIcon() {
      const sortType = this.sortFields.sortByTime;
      return this.sortIconMap[sortType];
    },
  },
  watch: {
    list(val) {
      this.renderTableHeader(val);
      this.refreshSelectedItem();
    },
    innerSelectedList() {
      this.refreshSelectedItem();
    },
    searchBarExist() {
      this.renderTable();
    },
  },
  mounted() {
    // 获取浏览器可视区域高度，动态加载表格高度
    eventProxy.on('winResize', this.renderTable);

    this.$nextTick(() => {
      this.fileBody = $('.tc-15-table-fixed-body');
      this.getHalfTableTop();
      this.fileBody.on('scroll', this.onTableScroll);

      this.renderTable();
      this.refreshSelectedItem();
    });
  },
  beforeDestroy() {
    this.fileBody && this.fileBody.off('scroll', this.onTableScroll);
    eventProxy.off('winResize', this.renderTable);
  },
  methods: {
    /**
     * 渲染表格样式
     * @param {Object} size 窗口的宽高 {height,width}
     */
    renderTable() {
      // 要等待面包屑导航渲染完成后再渲染表格高度
      this.$nextTick(() => {
        this.renderTableHeader(this.list);
        this.renderClientHeight();
      });
    },
    // 渲染表格表头：根据是否有滚动条设置表头不同的样式
    renderTableHeader(list) {
      const scrollBarWidth = getScrollbarWidth;
      const tableHeader = $('.custom-file .tc-15-table-fixed-head');
      const limit = this.tableBodyHeight / 60;
      if (list.length > limit) {
        tableHeader.css('padding-right', `${scrollBarWidth}px`);
      } else {
        tableHeader.css('padding-right', 0);
      }
    },
    renderClientHeight() {
      const headerHeight = 97;
      const offsetTop = 140;
      const padding = 40;
      const { clientHeight } = document.documentElement;
      const pagination = 50;
      const searchBarHeight = this.searchBarExist ? 0 : 28;
      const tableHeight = clientHeight
        - offsetTop
        - headerHeight
        - padding
        - pagination
        + searchBarHeight;
      this.tableHeight = Math.max(tableHeight, 200);
    },
    // 获取表格中间相对窗口的高度
    getHalfTableTop() {
      const { fileBody } = this;
      const halfTableHeight = fileBody.height() / 2;
      const tableFixedBodyTop = fileBody.offset().top;
      this.halfTableTop = halfTableHeight + tableFixedBodyTop;
    },
    onEventAction(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.index) {
        target = target.parentNode;
      }
      const { index, action } = target.dataset;
      this.action = action || '';
      if (action) {
        this.selectedItem = this.list[index];
        switch (action) {
          case 'dropmenu': {
            this.openDropmenu(target);
            break;
          }
          default:
            this.onAction(action);
            break;
        }
      }
    },
    onAction(action, flag) {
      const val = { item: this.selectedItem, action };
      if (flag === 'contextmenu') {
        if (this.innerSelectedList.length > 1) {
          delete val.item;
        } else {
          [val.item] = this.innerSelectedList;
        }
      }
      this.$emit('on-action', val);
    },
    openDropmenu(target) {
      const item = this.selectedItem;
      const isArc = ['ARCHIVE', 'DEEP_ARCHIVE'].includes(item.StorageClass);
      // 判断是否允许打开预览
      let previewType = '';
      if (isAllowPreviewImageKey(item.key)) {
        previewType = 'image';
      } else if (isAllowPreviewVideoKey(item.key)) {
        previewType = 'video';
      } else if (isAllowPreviewAudioKey(item.key)) {
        previewType = 'audio';
      }
      const allowPreview = !!previewType;
      this.dropmenuOptions = {
        allowDetail: !item.isDir,
        allowPreview: !item.isDir && allowPreview,
        previewType, // 预览选项
        allowShare: !isArc,
        allowRename: !item.isDir && !isArc,
      };
      let dropmenuItemsNum = config.fileDesktopDropmenuNum;
      Object.keys(this.dropmenuOptions).forEach(key => {
        const value = this.dropmenuOptions[key];
        if (typeof value === 'boolean' && !value) {
          dropmenuItemsNum--;
        }
      });
      const targetOffset = $(target).offset();
      const [targetX, targetY] = [targetOffset.left, targetOffset.top];
      const [targetW, targetH] = [target.clientWidth, target.clientHeight];

      const dropmenuH = 30 * dropmenuItemsNum;
      const dropmenuW = this.$store.localeLanguage === 'zh' ? 100 : 176.5;

      const left = targetX + targetW - dropmenuW;
      // 下拉菜单的展开方向
      const dropdownDirection = targetY - this.halfTableTop <= 0 ? 'down' : 'up';
      const top = dropdownDirection === 'down'
        ? targetY + targetH + 5
        : targetY - dropmenuH - 5;

      this.dropmenuPosition = { left, top };
      this.dropmenuShow = true;
    },
    refreshSelectedItem() {
      const self = this;
      setTimeout(() => {
        $(self.$el)
          .find('.finder-item')
          .off('dblclick')
          .on('dblclick', e => {
            const item = self.list[$(e.currentTarget).index()];
            if (item) {
              self.actionProxy = { item, action: 'openFiles' };
            }
          })
          .off('contextmenu')
          .on('contextmenu', e => {
            self.contextMenuShow = true;
            self.contextMenuPosition = { x: e.clientX, y: e.clientY };
            self.dropmenuShow = false;
            const item = self.list[$(e.currentTarget).index()];
            const itemInSelectedList = self.innerSelectedList.filter(
              selectedItem => selectedItem.name === item.name,
            );
            if (itemInSelectedList.length === 0) {
              self.innerSelectedList.forEach(i => {
                i.checked = false;
              });
              item.checked = true;
              self.innerSelectedList = [item];
            } else {
              const selectedList = [...self.innerSelectedList, item];
              self.innerSelectedList = self.deduplication(selectedList);
            }
            e.stopPropagation();
            e.preventDefault();
          })
          .removeClass('active')
          // .attr('draggable', false)
          .has('div.finder-item-name.checked')
          .addClass('active');
        // .attr('draggable', true);
      });
    },
    deduplication(list) {
      // 从后往前去重
      let index = list.length - 1;
      const hasNodeId = {};
      const deleteKey = [];
      while (index >= 0) {
        const { name } = list[index];
        if (hasNodeId[name]) {
          list.splice(index, 1);
          deleteKey.push(name);
        }
        hasNodeId[name] = true;
        index--;
      }
      return list;
    },
    // 为表格绑定滚动事件
    onTableScroll() {
      this.$emit('on-scroll');
      if (this.dropmenuShow) {
        this.dropmenuShow = false;
      }
      if (this.contextMenuShow) {
        this.contextMenuShow = false;
      }
    },
    onClickOutside(e) {
      const $path = $(e.target).parents().add(e.target);
      const isContextMenu = $path.hasClass('context-menu-content');
      if (isContextMenu) return;
      // 点击非表格区域则初始化dropmenu所需变量
      this.action = '';
      this.dropmenuShow = false;
      this.contextMenuShow = false;
    },
    showInRemoteFolder(item) {
      this.$emit('on-show-key', item);
    },
    resetSortStatus() {
      this.sortFields.sortBySize = 'none';
      this.sortFields.sortByTime = 'none';
    },
    sortClick(type) {
      // 当前排序项按顺序执行
      const sorts = ['none', 'desc', 'asc'];
      const sorting = this.sortFields[type];
      const sortingIndex = sorts.indexOf(sorting);
      const nextIndex = sortingIndex === sorts.length - 1 ? 0 : sortingIndex + 1;
      this.sortFields[type] = sorts[nextIndex];
      // 别的排序项置为none
      const sortList = Object.keys(this.sortFields);
      sortList.forEach(item => {
        if (item !== type && this.sortFields[item] !== 'none') {
          this.sortFields[item] = 'none';
        }
      });
      this.$emit('on-sort-change', this.sortFields[type]);
    },
  },
};
</script>

<style scoped lang="scss">
.tc-g.cos-table-operate {
  .tc-g-u-1-3 {
    padding-right: 0;
  }
}

// 在当前作用域调整表格高度
::v-deep .tc-15-table-fixed-body {
  .tc-15-table-box {
    tbody > tr {
      height: 55px;
    }
  }
}
</style>
